import { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'

const TEXTURES = [
  ['tile1', '1 block'],
  ['tile2', '2 block'],
  ['tile3', '3 block'],
  ['tile4', '4 block'],
  ['tile5', '5 block'],
  ['tile6', '6 block'],
  ['tile7', '7 block'],
  ['tile8', '8 block'],
  ['tileUnrevealed', 'Unrevealed block'],
  ['tileRevealed', 'Revealed block'],
  ['tileFlagged', 'Flagged block'],
  ['redSpot', 'Exploded mine'],
  ['menu1', 'Arcade menu block'],
  ['menu2', 'Campaign menu block'],
  ['menu3', 'Time Crisis menu block'],
  ['menu4', 'Sandbox menu block']
]

const PickerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const TilePickerStyled = styled.div`
  width: 128px; height: 128px;
  position: relative;
  margin: 0 15px 15px 0;
`
const AbsCover = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`
const ReplaceButton = styled.button`
  background: white;
  border: none;
  box-shadow: 1px 1px 10px rgba(0,0,0,0.4);
  border-radius: 10px;
  padding: 5px 15px;
`

const TilePicker = ({
  texName, niceName, textures, setTextures
}) => {
  const [texURL, setTexURL] = useState(`/textures/${texName}.png`)
  const [renderTooltip, setRenderTooltip] = useState(false)
  const fileInput = useRef()

  // ReactTooltip doesn't support SSR
  useEffect(() => {
    setRenderTooltip(true)
  }, [])

  function browseForImage () {
    fileInput.current.click()
  }
  function fileSelected (e) {
    const file = e.target.files[0]
    if (!file) return

    // Render preview blob
    const reader = new FileReader()
    reader.onloadend = () => {
      setTexURL(reader.result)
    }
    reader.readAsDataURL(file)

    // Inform upstream component for upload later
    setTextures({
      ...textures,
      [texName]: file
    })
  }

  return (
    <>
      <TilePickerStyled data-tip data-for={texName}>
        <img src={texURL} width={128} height={128} />
        <AbsCover>
          <ReplaceButton onClick={browseForImage}>Replace...</ReplaceButton>
          <input
            type='file'
            ref={fileInput}
            accept='image/*'
            onChange={fileSelected}
            style={{ display: 'none' }}
          />
        </AbsCover>
      </TilePickerStyled>
      {renderTooltip && (
        <ReactTooltip place='top' type='light' className='tooltip' effect='solid' id={texName}>
          <span>{niceName}</span>
        </ReactTooltip>
      )}
    </>
  )
}

const SkinImagePicker = ({ textures, setTextures }) => {
  return (
    <PickerContainer>
      {
        TEXTURES.map(t => (
          <TilePicker
            key={t[0]}
            texName={t[0]}
            niceName={t[1]}
            textures={textures}
            setTextures={setTextures}
          />
        ))
      }
    </PickerContainer>
  )
}

export default SkinImagePicker
export { TEXTURES, PickerContainer, TilePickerStyled }
